// src/routes/HPanelRoutes.js

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HPanelLayout from "../layouts/HPanelLayout";
import AdminProtectedRoute from '../components/AdminProtectedRoute';

// HPanel Pages
import Login from '../pages/hpanel/Auth/Login';
import ForgotPassword from '../pages/hpanel/Auth/ForgotPassword';
import ResetPassword from '../pages/hpanel/Auth/ResetPassword';
import Dashboard from "../pages/hpanel/Dashboard/Dashboard";
import CandidatesList from "../pages/hpanel/Candidates/CandidatesList";
import CandidateView from "../pages/hpanel/Candidates/CandidateView";
import CandidateForm from "../pages/hpanel/Candidates/CandidateForm";

import JobForm from "../pages/hpanel/Jobs/JobForm";
import JobsList from "../pages/hpanel/Jobs/JobsList";
import JobView from "../pages/hpanel/Jobs/JobView";

import EmployersList from "../pages/hpanel/Employers/EmployersList";
import EmployerView from "../pages/hpanel/Employers/EmployerView";
import EmployerForm from "../pages/hpanel/Employers/EmployerForm";

import BlogsList from "../pages/hpanel/Blogs/BlogsList";
import BlogForm from "../pages/hpanel/Blogs/BlogForm";

/*
import EmployerList from "../pages/hpanel/employers/EmployerList";
import EmployerView from "../pages/hpanel/employers/EmployerView";

*/

export default function HPanelRoutes() {
  return (
    <Routes>
      {/* Admin Auth Routes (without layout) */}
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected Admin Routes (with layout) */}
      <Route path="/" element={
        <AdminProtectedRoute>
          <HPanelLayout />
        </AdminProtectedRoute>
      }>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Candidates */}
        {/* <Route path="/candidates" element={<CandidateList />} />
        <Route path="/candidates/:id" element={<CandidateView />} /> */}
        <Route path="/candidates" element={<CandidatesList />} />
        <Route path="/candidates/add" element={<CandidateForm />} />
        <Route path="/candidates/edit/:id" element={<CandidateForm />} />
        <Route path="/candidates/:id" element={<CandidateView />} />

        {/* Jobs */}
        <Route path="jobs" element={<JobsList />} />
        <Route path="jobs/add" element={<JobForm />} />
        <Route path="jobs/edit/:id" element={<JobForm />} />
        <Route path="jobs/:id" element={<JobView />} />

        {/* Employers */}
        <Route path="employers" element={<EmployersList />} />
        <Route path="employers/add" element={<EmployerForm />} />
        <Route path="employers/edit/:id" element={<EmployerForm />} />
        <Route path="employers/:id" element={<EmployerView />} />

        {/* Blogs */}
        <Route path="blogs" element={<BlogsList />} />
        <Route path="blogs/add" element={<BlogForm />} />
        <Route path="blogs/edit/:id" element={<BlogForm />} />

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/hpanel/dashboard" replace />} />
        
        {/* Fallback */}
        {/* <Route path="*" element={<Dashboard />} /> */}
      </Route>
    </Routes>  
  );
}
